import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch } from "react-router-dom";
// Styles
// Import Flag Icons Set
import "flag-icon-css/css/flag-icon.min.css";
// Import Font Awesome Icons Set
import "font-awesome/css/font-awesome.min.css";
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
// Import Main styles for this application
import "../scss/style.scss";
// Temp fix for reactstrap
import "../scss/core/_dropdown-menu-right.scss";

// Containers
import Full from "./containers/Full/Full";

// Views
import Login from "./views/Pages/Login/Login";
import ForgottenPassword from "./views/Pages/ForgottenPassword/ForgottenPassword";
import NewPassword from "./views/Pages/NewPassword/NewPassword";
import Register from "./views/Pages/Register/Register";
import Page404 from "./views/Pages/Page404/Page404";
import Page500 from "./views/Pages/Page500/Page500";
import RedirectionForgottenPassword from "./views/Pages/RedirectionForgottenPassword/RedirectionForgottenPassword";

ReactDOM.render(
  <HashRouter>
    <Switch>
      <Route exact path="/login" name="Login Page" component={Login} />
      <Route
        exact
        path="/forgottenpassword"
        name="ForgottenPassword"
        component={ForgottenPassword}
      />
      <Route
        exact
        path="/newpassword/:email/:token"
        name="NewPassword"
        component={NewPassword}
      />
      <Route
        exact
        path="/redirected"
        name="Password changed"
        component={RedirectionForgottenPassword}
      />
      <Route exact path="/register" name="Register Page" component={Register} />
      <Route exact path="/404" name="Page 404" component={Page404} />
      <Route exact path="/500" name="Page 500" component={Page500} />
      <Route path="/" name="Home" component={Full} />
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js